export default __webpack_public_path__ + "static/media/ic_gift_success.dfe1e97a.svg";